import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGcUGmRzY_jsD3niQwheeA4eX_uRvGwi8",
  authDomain: "hatmecem.firebaseapp.com",
  projectId: "hatmecem",
  storageBucket: "hatmecem.appspot.com",
  messagingSenderId: "488091987705",
  appId: "1:488091987705:web:7e379eb6bb50a0329a3c28",
  measurementId: "G-KP9CYHGH2Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const db = getFirestore(app);


const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
